// Mesh positions measured for De IJssel.
export const deIjsselGeometry = {
  upperCenterMm: 2237.3,
  offsetMm: -25,
} as const;
